import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        pedidos: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        userDP: {
            id_customer: null,
            firstname: null, 
            lastname: null, 
            email: null,
            kuest: null, 
            address: null
        },
        event_options: null,
        order: null,
        stats: null,
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchPedidos({commit}, pagination) {
        const response = await axios.post(`/offline/order?page=${pagination.currentPage}`, {...pagination});
        commit('SET_ORDERS', response.data)
    },
    async getStats({commit}, data) {
        const response = await axios.post(`/offline/order/stats`, data);
        commit('SET_STATS', response.data)
    },
    async fetchEventOptions({commit}) {
        const response = await axios.post(`/offline/order/events`);
        commit('SET_EVENTS_OPTIONS', response.data)
    },
    async validateQR({commit}, qr) {
        const response = await axios.post(`/offline/order/QR`, {qr});
        commit('SET_USER', response.data);
        return response.data.success;
    },
    async resetQR({commit}) {
        commit('RESET_USER');
    },
    async fetchById({commit}, id) {
        // commit('SET_ORDER', null);
        const response = await axios.get(`/offline/order/${id}/show`,);
        commit('SET_ORDER', response.data);
        return response.data.success;
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async findProduct({commit}, product) {
        const response = await axios.post(`/offline/order/findProduct`, {...product});
        return response.data;
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async validOrder({commit}, order) {
        const response = await axios.post(`/offline/order/validOrder`, {...order});
        return response.data;
    },
    async downloadTicket({commit}, data) {
        const response = await axios.post(`/offline/order/downloadTicket`, data, { responseType: "blob" });
        const filename = `PEDIDO-` + data.order_id + '.pdf';
        downloadFile(filename, response.data);
    },
}

export const mutations = {
    updateField,
    SET_ORDERS: (state, result) => {
        state.pedidos = {
            items: [],
            from: result.from,
            to: result.to,
            total: result.total
        }
        let objectArray = Object.entries(result.data);

        objectArray.forEach(([key, value]) => {
            key;
            state.pedidos.items.push(value)
        });
    },
    SET_USER: (state, result) => {
        if(result.success){
            state.userDP = {
                id_customer: result.customer.id_customer,
                firstname: result.customer.firstname, 
                lastname: result.customer.lastname, 
                email: result.customer.email,
                kuest: result.customer.kuest,
                address: result.customer.address
            }
        }
    },
    RESET_USER: (state) => {
        state.userDP = null
    },
    SET_EVENTS_OPTIONS: (state, result) => {
        state.event_options = result
    },
    SET_ORDER: (state, result) => {
        state.order = result.data
    },
    SET_STATS: (state, result) => {
        state.stats = result
    }
}